import React from 'react'

import Layout from '../layouts/zh'
import SEO from '../components/seo'

import {
  appendix1,
  appendix2,
  appendix3,
  appendix4,
} from '../data/Appendices'

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="附錄" />

    <div className="container mt-8 font-normal">
      <div>
        <table className="mb-12 appendices" data-aos="fade-up">
          <colgroup>
            <col style={{ width: '33.3333%', minWidth: '33.3333%' }}></col>
            <col style={{ width: '33.3333%', minWidth: '33.3333%' }}></col>
            <col style={{ width: '33.3333%', minWidth: '33.3333%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th colSpan="3">附錄 I - 出版書刊 / 章節</th>
            </tr>
            <tr>
              <th>作者</th>
              <th>書名 / 題目</th>
              <th>出版商</th>
            </tr>
          </thead>

          <tbody>
            {
              appendix1.map((item, i) => (
                <tr key={i}>
                  <td dangerouslySetInnerHTML={{ __html: item.author['zh'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.title['zh'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.publisher['zh'].join('<br/>') }}></td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>

      <div>
        <table className="mb-12 appendices" data-aos="fade-up">
          <colgroup>
            <col style={{ width: '33.3333%', minWidth: '33.3333%' }}></col>
            <col style={{ width: '33.3333%', minWidth: '33.3333%' }}></col>
            <col style={{ width: '33.3333%', minWidth: '33.3333%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th colSpan="3">附錄 II - 在學術期刊出版的論文</th>
            </tr>
            <tr>
              <th>作者</th>
              <th>論文題目</th>
              <th>學術期刊名稱</th>
            </tr>
          </thead>

          <tbody>
            {
              appendix2.map((item, i) => (
                <tr key={i}>
                  <td dangerouslySetInnerHTML={{ __html: item.author['zh'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.title['zh'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.publisher['zh'].join('<br/>') }}></td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>

      <div>
        <table className="mb-12 appendices" data-aos="fade-up">
          <colgroup>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th colSpan="4">附錄 III - 在研討會發表或收錄於論文集的論文</th>
            </tr>
            <tr>
              <th>作者</th>
              <th>發表論文題目</th>
              <th>研討會</th>
              <th>地點和年份</th>
            </tr>
          </thead>

          <tbody>
            {
              appendix3.map((item, i) => (
                <tr key={i}>
                  <td dangerouslySetInnerHTML={{ __html: item.author['zh'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.paper['zh'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.conference['zh'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.placeAndDate['zh'] }}></td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>

      <div>
        <table className="mb-4" data-aos="fade-up">
          <colgroup>
            <col style={{ width: '75%', minWidth: '75%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th colSpan="2">附錄 IV - 獎助學金</th>
            </tr>
            <tr>
              <th>獎學金</th>
              <th>得獎者人數</th>
            </tr>
          </thead>

          <tbody>
            {
              appendix4.map((item, i) => {
                if (item.count === null) {
                  return (
                    <tr key={i}>
                      <td colSpan="2" className="font-bold bg-gray-400">{ item.name['zh'] }</td>
                    </tr>
                  )
                }
                return (
                  <tr key={i}>
                    <td className={`${item.bold ? 'font-bold bg-gray-400' : ''}`} dangerouslySetInnerHTML={{ __html: item.name['zh'] }}></td>
                    <td className={`${item.bold ? 'bg-gray-400' : ''} text-right`} dangerouslySetInnerHTML={{ __html: item.count }}></td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>

      <div className="text-base my-4 mb-12">
        註：以上名單為學年內新增的得獎學生，如屬續期的學生不計在內。
      </div>
    </div>
  </Layout>
)

export default IndexPage
